import { ComponentType } from "react"
import {
  Building02,
  CoinsHand,
  Compass03,
  IconProps,
  PieChart04,
} from "@mezo-org/mezo-clay"

import { routes } from "./routes"

export type SidebarNavigationItemProps = {
  navigationTitle: string
  pageTitle: string
  route: string
  Icon: ComponentType<IconProps>
  posthogDataAttribute: string
}

export const NAVIGATION_ITEMS: SidebarNavigationItemProps[] = [
  {
    navigationTitle: "Overview",
    pageTitle: "Overview",
    route: routes.OVERVIEW,
    Icon: PieChart04,
    posthogDataAttribute: "sidebar-overview",
  },
  {
    navigationTitle: "Borrow",
    pageTitle: "Borrow",
    route: routes.BORROW,
    Icon: CoinsHand,
    posthogDataAttribute: "sidebar-borrow",
  },
  {
    navigationTitle: "Market",
    pageTitle: "Market",
    route: routes.MARKET,
    Icon: Building02,
    posthogDataAttribute: "sidebar-market",
  },
  {
    navigationTitle: "Explore",
    pageTitle: "Explore",
    route: routes.EXPLORE,
    Icon: Compass03,
    posthogDataAttribute: "sidebar-explore",
  },
]

export const SIDEBAR_NAVIGATION_WIDTH = "220px"
